import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RestService } from '../../service/rest.service';
import { Message } from '../../service/message.service';
import { LoaderService } from '../../service/loader.service';
import { SeoService } from '../../service/seo.service';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styles: [],
  standalone: false
})
export class PricingComponent implements OnInit {
  constructor(private router: Router,private loader:LoaderService, private location: Location, private rest: RestService,private message:Message, private seo: SeoService) { }

  currentType = 0
plans :any[]=[]
  ngOnInit(): void {
    this.seo.updateSeo({
      metadescription: 'I nostri piani di abbonamenti sono distinti per imprese ed enti pubblici'
    });
    const params = new URLSearchParams(window.location.search);
    const paid = params.get("paid");
    if(paid == 'false'){
      this.message.showMessage('Pagamento annullato','error')
    }
    if(paid == 'true'){
      this.loader.on()
      this.rest.get('/user/me').subscribe({
        next:(value)=> {
          localStorage.setItem('user',JSON.stringify(value))
          this.loader.off(true)
          this.router.navigate(['profilo'])
        },
        error:(value)=> {
          this.loader.off(true)
          this.router.navigate(['profilo'])
        },
      })
      this.message.showMessage('Ti sei abbonato con successo','success')
      
    }
    this.getPlans()
  }

  goTo() {
    this.message.showMessage('Il piano arriverà in futuro','error')
  }

getPlans(){
  this.rest.get('/plan').subscribe({
    next:(value:any)=> {
      this.plans =value.data.map((res:any)=>{
        if(res.description){
        res.descriptions = res.description.split('/')
      }
        return res
      })
    },
  })
}

scrollTop(){
    let containerWeb = document.getElementById('container-web')
    if (containerWeb) {
      containerWeb.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  fakeGoTo(plan: any) {
    if(plan.contactUs)
      return this.goContact();
    let token = localStorage.getItem('token')
    let role = JSON.parse(localStorage.getItem('user') ?? '')?.role
    if (token) {
      if (role == 2 || role == 3 || role == 4) {
        this.loader.on()
        this.rest.post('/stripe/checkout/plan', { planId: plan.id }).subscribe({
          next: (value: any) => {
            this.loader.off(true)
            window.location.replace(value.url);
          },
        });
      } else {
        this.message.showMessage('Hai gia un piano attivo', 'error')
      }
    } else {
      this.message.showMessage('Devi essere loggato per acquistare un piano', 'error')
    }
  }

  goContact(){
    this.router.navigate(['/contatti']);
    this.scrollTop()
  }

}
